import type { WorkCalendar } from '@hana/work-calendar';
import { leaveBalance, type MeePerson, type MeeRequest } from '../data';
import { dayNo, dm, dowOf } from '../home/view';

export type AbsenceKind = 'leave' | 'pending' | 'trip' | 'off' | '';
export interface AbsenceRow {
  id: string;
  cells: { day: string; kind: AbsenceKind; wait?: boolean }[];
}

const dayKey = (n: number): string => new Date(n * 86_400_000).toISOString().slice(0, 10);

/** Đơn chờ duyệt của nhóm, người gửi trong `team` (mới gửi trước). Chỉ quản lý có `team`. */
export function pendingOfTeam(requests: readonly MeeRequest[], team: readonly string[]): MeeRequest[] {
  return requests
    .filter((r) => team.includes(r.owner) && r.status === 'Pending')
    .sort((a, b) => b.from.localeCompare(a.from) || b.id.localeCompare(a.id));
}

/** Lịch vắng của nhóm `days` ngày từ `from`: nghỉ đã duyệt · chờ duyệt · công tác · ngày nghỉ theo lịch công ty. */
export function absenceGrid(cal: WorkCalendar, team: readonly string[], requests: readonly MeeRequest[], from: string, days: number): AbsenceRow[] {
  return team.map((id) => ({
    id,
    cells: Array.from({ length: days }, (_, i) => {
      const day = dayKey(dayNo(from) + i);
      if (!cal.isWorkDay(day)) return { day, kind: 'off' as const };
      const hit = requests.find((r) => r.owner === id && (r.type === 'leave' || r.type === 'trip') && (r.status === 'Approved' || r.status === 'Pending') && r.from <= day && (r.to ?? r.from) >= day);
      const kind: AbsenceKind = !hit ? '' : hit.type === 'trip' ? 'trip' : hit.status === 'Pending' ? 'pending' : 'leave';
      return { day, kind, wait: hit?.status === 'Pending' };
    }),
  }));
}

/** Phép năm còn lại của người gửi (chỉ khi đơn là Phép năm). */
export function leftLabel(cal: WorkCalendar, people: readonly MeePerson[], requests: readonly MeeRequest[], r: MeeRequest): string {
  const p = people.find((x) => x.id === r.owner);
  if (!p || r.type !== 'leave' || r.sub !== 'Phép năm') return '—';
  return String(leaveBalance(cal, p, requests).left).replace('.', ',');
}

export const dayHead = (day: string): string => `${dowOf(day)} ${dm(day).slice(0, 2)}`;
